import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Zanting"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_569_46515)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.433594 8.00014C0.433594 3.82118 3.8213 0.433472 8.00026 0.433472C12.1792 0.433472 15.5669 3.82118 15.5669 8.00014C15.5669 12.1791 12.1792 15.5668 8.00026 15.5668C3.8213 15.5668 0.433594 12.1791 0.433594 8.00014ZM8.00026 2.23347C4.81542 2.23347 2.23359 4.81529 2.23359 8.00014C2.23359 11.185 4.81542 13.7668 8.00026 13.7668C11.1851 13.7668 13.7669 11.185 13.7669 8.00014C13.7669 4.81529 11.1851 2.23347 8.00026 2.23347Z" fill="#5587FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.73359 5.09998C7.00974 5.09998 7.23359 5.32383 7.23359 5.59998V10.4C7.23359 10.6761 7.00974 10.9 6.73359 10.9H5.93359C5.65745 10.9 5.43359 10.6761 5.43359 10.4V5.59998C5.43359 5.32383 5.65745 5.09998 5.93359 5.09998H6.73359Z" fill="#5587FF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0666 5.09998C10.3427 5.09998 10.5666 5.32383 10.5666 5.59998V10.4C10.5666 10.6761 10.3427 10.9 10.0666 10.9H9.2666C8.99046 10.9 8.7666 10.6761 8.7666 10.4V5.59998C8.7666 5.32383 8.99046 5.09998 9.2666 5.09998H10.0666Z" fill="#5587FF"></path></g><defs><clipPath id="clip0_569_46515"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var zanting = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { zanting as default };
